import * as React from "react";
import { useAppointmentContext } from "../../../../../context/v3/pages/BookAppointment/context/AppointmentContext.js";
import { useRoutingContext } from "../../../../../context/RoutingContext/v3/pages/BookAppointment/context/RoutingContext/context.js";
import useBookAppointmentType from "../../../../api/v3/pages/BookAppointment/hooks/api/use-book-appointment-type.js";
import useVirtualAppointment from "./use-virtual-appointment.js";
import { fromArrayToString } from "../../../../../../../utils/v3/utils/from-array-to-string.js";
const useBookAppointmentTypeWithUrlParam = () => {
  const [, { queryParams }] = useRoutingContext();
  const [getBookAppointmentType, { error, loading, called, data }] = useBookAppointmentType();
  const [{ setType }, { type: typeFromContext }] = useAppointmentContext();
  const [{ getAppointmentTypeData }, { typeId: virtualTypeId }] = useVirtualAppointment();
  React.useEffect(() => {
    if (error) {
      console.error(error);
      return;
    }
    const typeIdFromUrl = fromArrayToString(queryParams.typeId);
    if (loading || !typeIdFromUrl || typeIdFromUrl === typeFromContext?.id) {
      return;
    }
    const isVirtualAppointmentTypeId = typeIdFromUrl === virtualTypeId;
    if (isVirtualAppointmentTypeId) {
      setType(getAppointmentTypeData());
      return;
    }
    getBookAppointmentType(typeIdFromUrl);
  }, [
    queryParams.typeId,
    typeFromContext,
    loading,
    error,
    virtualTypeId,
    setType,
    getAppointmentTypeData,
    getBookAppointmentType
  ]);
  React.useEffect(() => {
    const typeIdFromAppointmentTypeInContext = typeFromContext?.id;
    const typeIdFromUrl = queryParams.typeId;
    if (!called || // query hasn't been called yet
    !data || loading || !typeIdFromUrl || typeIdFromUrl !== data.id || // query has been called but the appointment type id in query is different than the one in url
    typeIdFromAppointmentTypeInContext === typeIdFromUrl) {
      return;
    }
    setType(data);
  }, [called, data, loading, setType, typeFromContext?.id, queryParams.typeId]);
};
export {
  useBookAppointmentTypeWithUrlParam as default
};
//# sourceMappingURL=use-book-appointment-type-with-url-param.js.map
